export default {
    // Set Filter
    selectAll: "Выбрать все",
    selectAllSearchResults: "Выбрать все результаты поиска",
    searchOoo: "Поиск...",
    blanks: "Заготовка",
    noMatches: "Нет совпадений.",
  
    // Number Filter & Text Filter
    filterOoo: "Фильтр...",
    equals: "Равно",
    notEqual: "Не равно",
  
    // Number Filter
    lessThan: "Меньше чем",
    greaterThan: "Больше чем",
    lessThanOrEqual: "Меньше или равно",
    greaterThanOrEqual: "Больше или равно",
    inRange: "В диапазоне",
    inRangeStart: "Кому",
    inRangeEnd: "От",
  
    // Text Filter
    contains: "Содержит",
    notContains: "Не содержит",
    startsWith: "Начинается с",
    endsWith: "Оканчивается на",
  
    // Date Filter
    dateFormatOoo: "Yyyy-mm-dd",
  
    // Filter Conditions
    andCondition: "И",
    orCondition: "ИЛИ",
  
    // Filter Buttons
    applyFilter: "Применить фильтр",
    resetFilter: "Сбросить фильтр",
    clearFilter: "Очистить фильтр",
    cancelFilter: "Отменить фильтр",
  
    // Side Bar
    columns: "Колонки",
    filters: "Фильтры",
  
    // columns tool panel
    pivotMode: "Опорный режим",
    groups: "Групировка строк",
    rowGroupColumnsEmptyMessage: "Перетащите сюда, чтобы установить группы строк",
    values: "Значения",
    valueColumnsEmptyMessage: "Перетащите сюда для агрегирования",
    pivots: "Метки столбцов",
    pivotColumnsEmptyMessage: "Перетащите сюда, чтобы установить метки столбцов",
  
    // Header of the Default Group Column
    group: "Группа",
  
    // Other
    loadingOoo: "Загрузка...",
    noRowsToShow: "Нет данных",
    enabled: "Включено",
  
    // Menu
    pinColumn: "Закрепить колонку",
    pinLeft: "Закрепить слева",
    pinRight: "Закрепить справа",
    noPin: "Не закреплено",
    valueAggregation: "Агрегация значений",
    autosizeThiscolumn: "Авторазмер этого столбца",
    autosizeAllColumns: "Авторазмер всех столбцов",
    groupBy: "Группировать по",
    ungroupBy: "Разгруппировать по",
    resetColumns: "Сброс столбцов",
    expandAll: "Развернуть все",
    collapseAll: "Свернуть все",
    copy: "Копировать",
    ctrlC: "Ctrl+C",
    copyWithHeaders: "Копировать с заголовками",
    paste: "Вставить",
    ctrlV: "Ctrl+V",
    export: "Экспорт",
    csvExport: "Экспорт CSV",
    excelExport: "Экспорт Excel (.xlsx)",
    excelXmlExport: "Экспорт Excel (.xml)"
  };
  